export default {
  removeEl: function ($el) {
    $el.fadeOut(function () {
      $el.remove();
    });
  },
  triggerFlash: function (type, message) {
    var $el = $('<div class="' + type + '">' + message + '</div>');
    $('.flash-messages').prepend($el);

    setTimeout(this.removeEl.bind(this, $el), 5000);
  },
  notice: function (message) {
    this.triggerFlash('notice', message);
  },
  alert: function (message) {
    this.triggerFlash('alert', message);
  }
};



// WEBPACK FOOTER //
// ./lib/assets/js/flash.js